import type { Client } from '@/api/clients/clientsApi.types';

export const MINIMUM_OWNER_NAME_LENGTH_FOR_MATCHING = 3;

function normalizeOwnerName(fullName: string): string {
  return fullName
    .split(/\s+/)
    .filter(function isNotEmpty(namePart) {
      return namePart.length > 0;
    })
    .join(' ')
    .toLowerCase();
}

export function findOwnersWithSameName(typedFullName: string, clients: Client[]): Client[] {
  const normalizedTypedName = normalizeOwnerName(typedFullName);
  if (normalizedTypedName.length < MINIMUM_OWNER_NAME_LENGTH_FOR_MATCHING) {
    return [];
  }
  return clients.filter(function hasSameName(client) {
    return normalizeOwnerName(client.fullName) === normalizedTypedName;
  });
}
